import {
    FR_EXPRESS_VIEW_MEASURES,
    FR_READING_VIEW_MEASURES,
    MEASURE,
} from '../../../constants/reading/MeasuresConstants';
import { INTERP, TITLE } from '../../../constants/shared/CommonConstants';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import { ASSESSMENT_STATUS } from '../shared/FeatureReportConstants';

const { RED, YELLOW, GREEN, BLUE, PROFICIENT, BELOW } = INTERP;
const { D8, EXPRESS } = LICENSE;
const {
    ABOVE_TITLE,
    WELL_BELOW_TITLE,
    BELOW_TITLE,
    NOT_PROFICIENT,
    AT_TITLE,
    BENCHMARK_TITLE,
    PROFICIENT_TITLE,
} = TITLE;
const { TRO, DO } = MEASURE;

export const MEASURE_TITLE_EXPRESS = {
    TRO_EXPRESS: 'Reading Comprehension',
    DO_EXPRESS: 'Decoding',
};
export const FR_EXPRESS_VIEW = {
    license: EXPRESS,
    measures: FR_EXPRESS_VIEW_MEASURES,
    levelTypeTitle: PROFICIENT_TITLE,
    levelTroTitles: {
        [RED]: WELL_BELOW_TITLE,
        [YELLOW]: BELOW_TITLE,
        [BLUE]: ABOVE_TITLE,
    },
    levelDoTitles: {
        [BELOW]: NOT_PROFICIENT,
        [PROFICIENT]: PROFICIENT_TITLE,
    },
};
export const FR_READING_VIEW = {
    license: D8,
    measures: FR_READING_VIEW_MEASURES,
    levelTypeTitle: BENCHMARK_TITLE,
    levelTitles: {
        [RED]: WELL_BELOW_TITLE,
        [YELLOW]: BELOW_TITLE,
        [GREEN]: AT_TITLE,
        [BLUE]: ABOVE_TITLE,
    },
};
export const FR_SUMMARY_VIEW_EXPRESS = {
    summarySectionClass: 'class-summary-section-express',
    showTotalStudentsCount: true,
    status: ASSESSMENT_STATUS.STUDENTS_ASSESSED,
    skills: [TRO, DO],
};
